var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconAlignCenter48Filled = function SvgIconAlignCenter48Filled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 18.5v-13h-2v13h2Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.05 9.5H6.95c-.8 0-1.45.69-1.45 1.543v1.914c0 .852.65 1.543 1.45 1.543h10.1c.8 0 1.45-.69 1.45-1.543v-1.914c0-.852-.65-1.543-1.45-1.543Z",
    fill: "current"
  })));
};
export default SvgIconAlignCenter48Filled;